import { DialogTitle } from "@mui/material";
import { deliveryNoteBusiness } from "api/bussiness/delivery-note/delivery-note-business";
import { dateTimeToUTCString } from "commons/ultilities/date/dayjs";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { DynamicFormArray } from "commons/ultilities/dynamic-form/components/dynamic-form-array";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import { IAddDeliveryNote } from "mobx-stores/_models/delivery-note/delivery-note";
import { useStores } from "mobx-stores/_root-store";
import { useResetCustomerDependentControls } from "pages/common/hooks/use-reset-customer-dependent-controls";
import { useCallback, useMemo } from "react";
import { DialogComplexContent } from "share-components/templates/form/dialog-complex-form/dialog-complex-content";
import { DialogComplexFormContainer } from "share-components/templates/form/dialog-complex-form/dialog-complex-form";
import { DialogComplexFormArrayContainer } from "share-components/templates/form/dialog-complex-form/dialog-complex-form-array";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { getAddDeliveryNoteFormSchema } from "../schema";

export const AddDeliveryNote = observer(() => {
  const {
    deliveryNoteManagement: { openNew, getDeliveryNotes, setProp },
  } = useStores();
  const {
    form: { controls, isValid },
    getControl,
    getControlArray,
    submitHandler,
  } = useForm<IAddDeliveryNote>((form) => getAddDeliveryNoteFormSchema(form), {
    date: dateTimeToUTCString(dayjs()),
    number: "",
    man: "",
    licensePalate: "",
    note: "",
    customerId: "",
    purchaseOrderId: "",
    deliveryAddressId: "",
    items: [
      {
        amount: 0,
        note: "",
        productId: "",
        mh: 0,
        package: 0,
        weight: 0,
      },
    ],
  });

  const saveHandler = useCallback(
    async (data: IAddDeliveryNote) => {
      try {
        await deliveryNoteBusiness.add(data);
        await getDeliveryNotes();
        setProp("openNew", false);
      } catch (ex) {
        console.error(ex);
      }
    },
    [getDeliveryNotes, setProp],
  );

  const itemControl = useMemo(() => {
    return getControl("items");
  }, [getControl]);

  const customerControl = useMemo(() => {
    return getControl("customerId");
  }, [getControl]);

  const deliveryAddressControl = useMemo(() => {
    return getControl("deliveryAddressId");
  }, [getControl]);

  useResetCustomerDependentControls({
    customerId: customerControl.value,
    controls: [{ control: deliveryAddressControl }],
    arrayChildControls: [
      {
        arrayControl: itemControl,
        childControlName: "productId",
      },
    ],
  });

  const deliveryNoteItems = useMemo(() => {
    return getControlArray("items");
  }, [getControlArray]);

  const removeRowHandler = useCallback(
    (idx: number) => {
      itemControl.removeChildByIndex(idx);
    },
    [itemControl],
  );

  const addNewDeliveryNoteItemRow = useCallback(() => {
    itemControl.addNewChild();
  }, [itemControl]);

  return (
    <DialogForm
      open={openNew}
      fullWidth
      maxWidth={"xl"}
      onClose={() => setProp("openNew", false)}
      onCancelBtnClicked={() => setProp("openNew", false)}
      onSaveBtnClick={async () => await submitHandler(saveHandler)}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Thêm phiếu giao hàng</DialogTitle>
      <DialogComplexContent>
        <DialogComplexFormContainer>
          <DynamicForm controls={controls}></DynamicForm>
        </DialogComplexFormContainer>
        <DialogComplexFormArrayContainer
          label={itemControl.label}
          addNewRow={addNewDeliveryNoteItemRow}
        >
          {deliveryNoteItems && deliveryNoteItems.length > 0 && (
            <DynamicFormArray
              containerProps={{
                sx: {
                  marginTop: "10px",
                  marginBottom: "10px",
                },
              }}
              children={deliveryNoteItems}
              onRemoveRowClick={removeRowHandler}
            ></DynamicFormArray>
          )}
        </DialogComplexFormArrayContainer>
      </DialogComplexContent>
    </DialogForm>
  );
});
